import { render, staticRenderFns } from "./task.vue?vue&type=template&id=0c4ced96&"
import script from "./task.vue?vue&type=script&lang=js&"
export * from "./task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4ced96')) {
      api.createRecord('0c4ced96', component.options)
    } else {
      api.reload('0c4ced96', component.options)
    }
    module.hot.accept("./task.vue?vue&type=template&id=0c4ced96&", function () {
      api.rerender('0c4ced96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/task.vue"
export default component.exports